import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Checkbox from '@kurtosys/ksys-app-components/dist/components/base/Checkbox';

export default InjectedStyledComponent(Checkbox, 'acceptance', ['checkbox']);